export enum PromotionType {
  SUBSIDY = 'SUBSIDY',
  EXCHANGE = 'EXCHANGE',
  DISCOUNT = 'DISCOUNT'
}
